import React from 'react';

const CouponInfo = ({calculationResult, accessFeatures}) => {
    const {
        couponName,
        rowName,
        maxLoanAmount,
        basePercent,
        delayPercent,
        overpaymentPerDay,
        overpaymentTotal
    } = calculationResult;
    return (
        <div className="form-row calculationLayout-row">
            <div className="form-row-item elements-center">
                <div className="form-element calculationLayout-element-width">
                    <div className="form-element-data static">
                        <p className="big">{couponName}</p>
                    </div>
                </div>
            </div>
            <div className="form-row-item">
                <div className="form-element calculationLayout-element">
                    <div className="form-element-data static">
                        {(accessFeatures["coupons.birthday.enable"] ||
                                accessFeatures["coupons.bonus.enable"]) &&
                            rowName && (
                                <p className={"letter-spacing font-bold"}>
                                    {rowName}
                                </p>
                            )}
                        {accessFeatures["max_loan_amount"] && (
                            <p>
                                Максимальная сумма микрозайма
                                <span className={"letter-spacing font-bold"}>
                          {maxLoanAmount} руб.
                        </span>
                            </p>
                        )}
                        <p>
                            Процент за пользование
                            <span className={"letter-spacing font-bold"}>
                        {basePercent} %.
                      </span>
                            Процент за неустойку
                            <span className={"letter-spacing font-bold"}>
                        {delayPercent} %.
                      </span>
                        </p>
                        <p>
                            Переплата за день
                            <span className={"letter-spacing font-bold"}>
                        {overpaymentPerDay !== 0
                            ? overpaymentPerDay.toFixed(2)
                            : 0}{" "}
                                руб.
                      </span>
                            / весь срок
                            <span className={"letter-spacing font-bold"}>
                        {overpaymentTotal !== 0
                            ? overpaymentTotal.toFixed(2)
                            : 0}{" "}
                                руб.
                      </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CouponInfo;